import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-2" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-lg-17" }
const _hoisted_6 = { class: "mb-18" }
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = { class: "card-title m-0" }
const _hoisted_9 = { class: "fw-bolder m-3" }
const _hoisted_10 = { class: "mt-15" }
const _hoisted_11 = { class: "card-title m-0" }
const _hoisted_12 = { class: "fw-bolder m-3" }
const _hoisted_13 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_14 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_15 = { class: "indicator-label" }
const _hoisted_16 = { class: "indicator-progress" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateOrganizerDescriptions')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Form, {
                class: "form",
                onSubmit: _ctx.onSubmitUpdate
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.translate('textInArabic')), 1)
                    ]),
                    _createVNode(_component_editor, {
                      apiKey: "w5u1bctf39vva9gmakhdohcnyu5masw0l071cxuykwj2sns0",
                      modelValue: _ctx.htmlAr,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.htmlAr) = $event)),
                      init: {
                  height: 500,
                  menubar: true,
                  directionality: 'rtl',
                  language: 'ar',
                  setup(editor) {
                    editor.on('init', () => {
                      editor.getBody().setAttribute('dir', 'rtl');
                      editor.getBody().style.textAlign = 'right';
                    });
                  },
                  content_css:
                    'https://fonts.googleapis.com/css2?family=Cairo:wght@600&display=swap',

                  // ✅ Add Cairo to the font dropdown
                  font_formats: `
    Cairo='Cairo', sans-serif;
    Arial=arial,helvetica,sans-serif;
    Courier New=courier new,courier,monospace;
    Georgia=georgia,palatino;
    Times New Roman=times new roman,times;
    Verdana=verdana,geneva;
  `,
                  content_style: `
    body, * {
      font-family: 'Cairo', sans-serif !important;
    }
  `,
                  plugins: [
                    'advlist autolink lists link image charmap preview anchor',
                    'searchreplace visualblocks visualchars code fullscreen',
                    'insertdatetime media table emoticons hr pagebreak',
                    'wordcount save directionality template codesample',
                    'nonbreaking toc autosave spellchecker help quickbars',
                  ],
                  toolbar: [
                    'undo redo | blocks fontselect fontsizeselect',
                    'bold italic underline strikethrough forecolor backcolor',
                    'alignleft aligncenter alignright alignjustify | outdent indent',
                    'bullist numlist | link image media table codesample | hr pagebreak',
                    'charmap emoticons | fullscreen preview save print | code help',
                  ].join(' | '),
                  quickbars_selection_toolbar:
                    'bold italic | quicklink h2 h3 blockquote',
                  quickbars_insert_toolbar: 'image media table',
                  toolbar_mode: 'sliding',
                  contextmenu:
                    'link image inserttable | cell row column deletetable',
                  image_advtab: true,
                  image_caption: true,
                  file_picker_types: 'image media file',
                  automatic_uploads: true,
                  paste_data_images: true,
                  relative_urls: false,
                  remove_script_host: false,
                  convert_urls: true,
                }
                    }, null, 8, ["modelValue", "init"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.translate('textInEnglish')), 1)
                    ]),
                    _createVNode(_component_editor, {
                      apiKey: "w5u1bctf39vva9gmakhdohcnyu5masw0l071cxuykwj2sns0",
                      modelValue: _ctx.htmlEn,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.htmlEn) = $event)),
                      init: {
                  height: 500,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap preview anchor',
                    'searchreplace visualblocks visualchars code fullscreen',
                    'insertdatetime media table emoticons hr pagebreak',
                    'wordcount save directionality template codesample',
                    'nonbreaking toc autosave spellchecker help quickbars',
                  ],
                  toolbar: [
                    'undo redo | blocks fontselect fontsizeselect',
                    'bold italic underline strikethrough forecolor backcolor',
                    'alignleft aligncenter alignright alignjustify | outdent indent',
                    'bullist numlist | link image media table codesample | hr pagebreak',
                    'charmap emoticons | fullscreen preview save print | code help',
                  ].join(' | '),
                  content_css:
                    'https://fonts.googleapis.com/css2?family=Cairo:wght@600&display=swap',

                  // ✅ Add Cairo to the font dropdown
                  font_formats: `
    Cairo='Cairo', sans-serif;
    Arial=arial,helvetica,sans-serif;
    Courier New=courier new,courier,monospace;
    Georgia=georgia,palatino;
    Times New Roman=times new roman,times;
    Verdana=verdana,geneva;
  `,
                  content_style: `
    body, * {
      font-family: 'Cairo', sans-serif !important;
    }
  `,
                  quickbars_selection_toolbar:
                    'bold italic | quicklink h2 h3 blockquote',
                  quickbars_insert_toolbar: 'image media table',
                  toolbar_mode: 'sliding',
                  contextmenu:
                    'link image inserttable | cell row column deletetable',
                  image_advtab: true,
                  image_caption: true,
                  file_picker_types: 'image media file',
                  automatic_uploads: true,
                  paste_data_images: true,
                  relative_urls: false,
                  remove_script_host: false,
                  convert_urls: true,
                }
                    }, null, 8, ["modelValue", "init"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('discard')), 1),
                    _createElementVNode("button", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_17
                      ])
                    ], 512)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}